import { Field } from 'common/fields/entities/field'

export const filterFieldMapper = (field: Field): Field => ({
  ...field,
  id: field.id.replace('integration_user_field.', '').replace('lcf_', '').replace('app.', ''),
})
